import { getUserFields } from "components/user/config";
import { fetchEmployee, getItemsFromCollection } from "directus/src/operations";

export async function fetchReceivedReviews({ quadId, employeeId }) {
  try {
    const query = {
      fields: ["id", "quadrimester", "status", getUserFields("reviewer")],
      filter: {
        quadrimester: { _eq: quadId },
        reviewee: { _eq: employeeId },
        reviewer: { _neq: employeeId },
      },
    };
    const response = await getItemsFromCollection("performance_review", query);
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
}

export async function fetchEmployeesSelfReview({ quadId, employeeId }) {
  try {
    const query = {
      fields: ["id", "quadrimester", "status", getUserFields("reviewee")],
      filter: {
        quadrimester: { _eq: quadId },
        reviewee: { _eq: employeeId },
        reviewer: { _eq: employeeId },
      },
    };
    const response = await getItemsFromCollection("performance_review", query);
    return response?.[0] || {};
  } catch (error) {
    console.log(error);
    return error;
  }
}

export async function fetchEmployeeById({ employeeId }) {
  try {
    const query = {
      fields: getUserFields(),
    };
    const response = await fetchEmployee(employeeId, query);
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
}
